<template>
<div id="product">
  <div class="sub-content-div">
    <div class="iot-main-width">
      <div class="main-sub-header">
        <el-button icon="el-icon-circle-plus-outline" type="primary" @click="productDialog.dialogFormVisible = true">添加产品</el-button>
        <el-dialog title="添加产品" :visible.sync="productDialog.dialogFormVisible">
          <el-form ref="productForm" :model="productDialog.form" label-width="120px">
            <el-form-item label="产品名称" prop="productName" :rules="rules.checkProductName">
              <el-input v-model="productDialog.form.productName"></el-input>
            </el-form-item>
            <el-form-item label="产品类型">
              <el-select v-model="productDialog.form.productProtocol" placeholder="请选择">
                <el-option label="数据端点" value="302"></el-option>
                <el-option label="ModBus" value="303"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产品描述" prop="productTip" :rules="rules.checkProductTip">
              <el-input type="textarea" v-model="productDialog.form.productTip"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="productDialog.dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="btnAddProduct" :loading="productDialog.btnSubmit.isLoading" style="width: 100px;">提 交</el-button>
          </div>
        </el-dialog>
        <!--<div style="float: right;height: 50px;width: 380px;">-->
          <!--<el-input placeholder="请输入搜索内容" v-model="searchProduct.searchText" class="input-with-select">-->
            <!--<el-select v-model="searchProduct.searchType" slot="prepend" style="width: 110px;">-->
              <!--<el-option label="产品名称" value="1"></el-option>-->
              <!--<el-option label="产品ID" value="2"></el-option>-->
            <!--</el-select>-->
            <!--<el-button slot="append" icon="el-icon-search"></el-button>-->
          <!--</el-input>-->
        <!--</div>-->
      </div>
      <div class="product-list-div" v-loading="productListLoading">
        <el-row :gutter="20">
          <el-col :span="8" v-for="item in productList" :key="item.id">
            <div class="product-pane">
              <div class="product-pane-title">
                <p class="text-elip"><i class="el-icon-tickets"></i>{{item.productName}}</p>
              </div>
              <div class="product-pane-content">
                <p><span class="span-name">产品ID：</span><span class="span-content">{{item.id}}</span></p>
                <p><span class="span-name en">ProductKey：</span><span class="span-content en">{{item.productKey}}</span></p>
                <p><span class="span-name">创建时间：</span><span class="span-content">{{item.gmtCreate}}</span></p>
                <p><span class="span-name">端点类型：</span><span class="span-content">{{item.productProtocolName}}</span></p>
              </div>
              <div class="product-pane-btn">
                <el-button round icon="el-icon-setting" @click="btnIntoDevice(item)" class="btn-fluid">进入管理界面</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import rules from '@/utils/rules.js'
export default {
  name: 'Product',
  data () {
    return {
      searchProduct: {
        searchText: '',
        searchType: '1'
      },
      productDialog: {
        dialogFormVisible: false,
        formLabelWidth: '120px',
        form: {
          productName: '',
          productTip: '',
          productProtocol: '302'
        },
        btnSubmit: {
          isLoading: false
        }
      },
      productList: [],
      productListLoading: false,
      rules
    }
  },
  created () {
    this.$store.commit('setTopLeftMenuIndex', '1')
    this.getProductList()
  },
  methods: {
    getProductList: function () {
      let that = this
      that.productListLoading = true
      // 获取产品列表
      let url = that.global.url.baseUrl + 'product/getProductList'
      let para = {
        params: {
        }
      }
      that.axios.get(url, para)
        .then(res => {
          that.productListLoading = false
          if (res.data.code === 406) {
            let pList = res.data.objList
            for (let n = 0; n < pList.length; n++) {
              pList[n].gmtCreate = that.global.dateFormat(pList[n].gmtCreate)
              pList[n].gmtModified = that.global.dateFormat(pList[n].gmtModified)
              if (pList[n].productProtocol === 302) {
                pList[n].productProtocolName = '数据端点'
              } else if (pList[n].productProtocol === 303) {
                pList[n].productProtocolName = 'ModBus'
              }
            }
            that.productList = pList
          }
        }, res => {
          console.log('出错：',res)
          that.productListLoading = false
          that.$message.error('网络错误')
        })
    },
    btnAddProduct: function () {
      console.log('提交产品')
      let that = this
      this.$refs['productForm'].validate((valid) => {
        if (valid) {
          let url = that.global.url.baseUrl + 'product/addProduct'
          let para = {
            productName: that.productDialog.form.productName,
            productProtocol: that.productDialog.form.productProtocol,
            productTip: that.productDialog.form.productTip
          }
          that.productDialog.btnSubmit.isLoading = true
          that.axios.post(url, para)
            .then(res => {
              that.productDialog.btnSubmit.isLoading = false
              if (res.data.code === 406) {
                console.log('新建产品成功')
                that.$message({
                  message: res.data.msg,
                  type: 'success'
                })
                that.getProductList()
                that.productDialog.dialogFormVisible = false
                that.$refs['productForm'].resetFields()
              } else {
                that.$message.error(res.data.msg)
              }
            }, res => {
              console.log('出错：',res)
              that.$message.error('网络错误')
              that.productDialog.btnSubmit.isLoading = false
            })
        } else {
          return false
        }
      })
    },
    btnIntoDevice: function (item) {
      this.$store.commit('setTopLeftMenuIndex', '0')
      this.$store.commit('setProduct', item)
      this.$router.push({
        name: 'productInfo'
      })
    }
  }
}
</script>

<style scoped>
  .sub-content-div{
    position: absolute;
    top: 60px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    overflow-y: auto;
  }

  .main-sub-header{
    height: 50px;
    padding-top: 10px;
  }

  /* product-pane */
  .product-list-div{
    padding-top: 20px;
    border-top: 1px solid #e6e6e6;
    min-height: 300px;
  }

  .product-pane {
    box-shadow: 0 0 8px #ddd;
    border: 1px solid #ddd;
    height: 300px;
    margin-top: 10px;
  }

  .product-pane:hover {
    box-shadow: 1px 1px 8px #999;
  }

  .product-pane-title {
    padding: 10px 0px;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #ddd;
  }

  .product-pane-title p {
    font-size: 20px;
    color: #535456;
  }

  .product-pane-title i {
    font-size: 24px;
    padding: 0px 10px;
  }

  .product-pane-content {
    padding: 20px 5px;
  }

  .product-pane-content>p {
    font-size: 14px;
    margin-bottom: 15px;
    color: #535456;
  }

  .product-pane-content .span-name {
    display: inline-block;
    text-align: right;
    width: 100px;
    color: #999;
  }

  .product-pane-content .en {
    font-size: 12px;
  }

  .product-pane-btn {
    padding: 0px 5px;
    text-align: center;
  }
</style>
